export default __webpack_public_path__ + "static/media/seller-img3.f137fa6a.png";